
import { defineComponent } from "vue";

export default defineComponent({
  name: "DrawerColumn",
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
});
